export default __webpack_public_path__ + "static/media/analyze.b16c3d07.svg";